import { Colors } from "../../../consts/Colors";
import FONTS from "../../../consts/Fonts";
import { tags } from "../../../consts/Tags";
import ButtonImage from "../../global/buttons/ButtonImage";
import ChoixText from "../../global/ChoixText";

export default class ChoixTextQ3 extends ChoixText {
    constructor(scene, x, y, config, endFunc) {
        super(scene, x, y, config, endFunc);
        this.currentIndex = -1;

    }

    addBody(){
        // Ajout du fond
        this.background = this.scene.add.rexRoundRectangle(0, 0, 292, 64, 8, Colors.Elmt.White).setOrigin(0.5);
        this.background.setStrokeStyle(2, Colors.Elmt.Grey)
        this.add(this.background);

        // Ajout du texte
        this.textElmt = this.scene.add.rexTagText(0, 0, '<class=\"Inter18Italic\">Sélectionnez votre réponse</class>', {
            fontSize: '20px',
            fontFamily: FONTS.Inter18Medium,
            color: Colors.Text.Black,
            tags: tags
        }).setOrigin(0.5);
        this.textElmt.setAlpha(0.4)
        this.add(this.textElmt);

        // Ajout bouton gauche
        this.leftButton = new ButtonImage(this.scene, -180, 0, {image: 'button_left', hoverTint: 0xffffff10})
        this.add(this.leftButton);
        this.leftButton.setClickFunction( () => {
            this.onLeftClick();
        })

        // Ajout bouton droit
        this.rightButton = new ButtonImage(this.scene, 180, 0, {image: 'button_left', hoverTint: 0xffffff10})
        this.rightButton.setFlipX(true)
        this.add(this.rightButton);
        this.rightButton.setClickFunction( () => {
            this.onRightClick();
        })
    }

}